// extracted by mini-css-extract-plugin
export var actionIcon = "_s8-0";